module.exports = __webpack_public_path__ + "static/media/gallery22.50d20880.jpeg";